var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74228e-07 10C1.02613e-06 8.26238 0.45277 6.55476 1.31369 5.04541C2.1746 3.53607 3.41395 2.2771 4.90959 1.39258C6.40522 0.508061 8.10553 0.028526 9.84293 0.0012328C11.5803 -0.0260604 13.2949 0.39983 14.8175 1.23693C16.3402 2.07403 17.6185 3.29345 18.5264 4.77501C19.4343 6.25657 19.9405 7.94913 19.9951 9.68589C20.0496 11.4226 19.6507 13.1437 18.8377 14.6793C18.0246 16.2149 16.8254 17.5122 15.3583 18.4433L14.0187 16.3325C15.119 15.6342 16.0184 14.6612 16.6282 13.5095C17.2381 12.3577 17.5372 11.067 17.4963 9.76442C17.4554 8.46185 17.0757 7.19243 16.3948 6.08126C15.7139 4.97009 14.7552 4.05553 13.6132 3.4277C12.4711 2.79987 11.1852 2.48045 9.8822 2.50092C8.57915 2.52139 7.30392 2.88105 6.18219 3.54443C5.06046 4.20782 4.13095 5.15205 3.48526 6.28406C2.83958 7.41607 2.5 8.69679 2.5 10L8.74228e-07 10Z",
    fill: "#1871E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.8c323aab00fa729b10bc15a4717c69d3.svg";
export { ForwardRef as ReactComponent };